import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class LicencaValidation extends DefaultValidation {
	validate(model, refs) {
		let validated = true;

		if (Util.isNull(model.numero)) {
			refs.numeroInput.focusedOut = true;
			validated = false;
		}
		if (Util.isNull(model.vencimento)) {
			refs.vencimentoInput.focusedOut = true;
			validated = false;
		}

    return validated;
	}
}